<template>
	<div>
		<div id="table-container">
			<table class="table table-hover ui-table">
				<thead>
					<tr>
						<th class="align-middle ts-whitespace-no-wrap text-center">
							{{ $t('administration.employee.employeeDailyTimescan.number') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap">
							{{ $t('administration.employee.employeeDailyTimescan.nameOfStaff') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap">
							{{
								$t('administration.employee.employeeDailyTimescan.sex')
							}}
						</th>
						<th class="align-middle ts-whitespace-no-wrap">
							{{ $t('administration.employee.employeeDailyTimescan.position') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap">
							{{ $t('administration.employee.employeeDailyTimescan.department') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap">
							{{ $t('administration.employee.employeeDailyTimescan.status') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap">
							{{ $t('administration.employee.employeeDailyTimescan.startingTimeAM') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap red">
							{{ $t('administration.employee.employeeDailyTimescan.timeInlateness') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap">
							{{ $t('administration.employee.employeeDailyTimescan.leavingTimeAM') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap">
							{{ $t('administration.employee.employeeDailyTimescan.startingTimePM') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap red">
							{{ $t('administration.employee.employeeDailyTimescan.timeInlateness') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap">
							{{ $t('administration.employee.employeeDailyTimescan.leavingTimePM') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap">
							{{ $t('administration.employee.employeeDailyTimescan.remarks') }}
						</th>
					</tr>
					<tr v-if="loading == true">
						<th colspan="5" class="table-data-loading">
							<div class="table-data-loading__sliders">
								<div class="table-data-loading__line"></div>
								<div class="table-data-loading__subline table-data-loading__subline__inc"></div>
								<div class="table-data-loading__subline table-data-loading__subline__dec"></div>
							</div>
						</th>
					</tr>
				</thead>
				<tbody v-for="(items, department_name) in dataAttendances">
					<tr>
						<td class="ts-whitespace-no-wrap" colspan="13">
							{{ department_name }}
						</td>
					</tr>
					<tr v-for="(record, index) in items" :key="index">
						<td class="ts-whitespace-no-wrap text-center">
							{{ index + 1 }}
						</td>
						<td class="ts-whitespace-no-wrap">
							{{ record.name_en ? record.name_en : '' }}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ record.gender == 1 ? 'M' : 'F' }}
						</td>
						<td class="ts-whitespace-no-wrap">
							{{ record.pos_name_en ? record.pos_name_en : '' }}
						</td>
						<td class="ts-whitespace-no-wrap">
							{{ record.department_name_en ? record.department_name_en : '' }}
						</td>
						<td class="ts-whitespace-no-wrap">
							{{ record.att_status }}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ tConvert(record.first_in) }}
						</td>
						<td class="ts-whitespace-no-wrap text-center red">
							{{ record.first_late }}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ tConvert(record.first_out) }}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ tConvert(record.second_in) }}
						</td>
						<td class="ts-whitespace-no-wrap text-center red">
							{{ record.second_late }}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ tConvert(record.second_out) }}
						</td>
						<td class="ts-whitespace-no-wrap"></td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	name: 'attendance-with-status',
	data() {
		return {
			loading: false,
			showForm: false
		}
	},
	created() { },
	computed: {
		...mapState('employeeDailyTimescan', ['dataAttendances', 'pagination']),
		...mapGetters('employeeDailyTimescan', ['tConvert'])
	}
}
</script>
<style scoped>
.no-padding-top {
	padding: 0 1rem 1rem 1rem;
}

#table-container {
	min-height: 60vh;
	overflow-y: scroll;
}

table>tbody>tr td {
	vertical-align: middle;
}

.table>thead>tr>th {
	border: 1px solid #b6c2c9;
	vertical-align: middle;
}

.red {
	color: red;
}

::-webkit-scrollbar {
	height: 8px;
	width: 3px;
	/* Remove scrollbar space */
	background: #ffff;
	/* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
	border-radius: 4px;
	background: #e5e7e7;
}

div::-webkit-scrollbar-thumb:hover {
	background: #b7b7b8;
}
</style>
